import { environment } from '../environments/environment';
import { SolApp } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { navbarPlatform } from './navbar-platform';
import { navbarPartner } from './navbar-partner';
import { AsmAuthority } from '@asm/components-core/models/asm-authority';
import { AsmLicensingAuthority } from '@asm/components-core/models/asm-licensing-authority';
import { AsmLicensingAuthorizationTools } from '@asm/components-core/tools/asm-licensing-authorization.tools';
import { AsmContextTools } from '@asm/components-platform-context/tools/asm-context-tools';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { navbarAdmin } from './navbar-admin';

export const apps: SolApp[] = [
  SolApp.ofInternal(
    AsmRouteId.app_platform,
    'Platform',
    SolIcon.application,
    'Client apps',
    navbarPlatform,
    [AsmAuthority.VIEW_PLATFORM_APP],
    AsmContextTools.APP_CONTEXT_PARAMS[AsmRouteId.app_platform],
  ),
  SolApp.ofInternal(
    AsmRouteId.app_partner,
    'Partner',
    SolIcon.users,
    'Client apps',
    navbarPartner,
    [AsmAuthority.VIEW_PARTNER_APP],
    AsmContextTools.APP_CONTEXT_PARAMS[AsmRouteId.app_partner],
  ),
  SolApp.ofInternal(
    AsmRouteId.app_admin,
    'Administration',
    SolIcon.internal,
    'Client apps',
    navbarAdmin,
    [AsmAuthority.VIEW_ADMIN_APP],
    AsmContextTools.APP_CONTEXT_PARAMS[AsmRouteId.app_admin],
  ),
  ...(AsmLicensingAuthorizationTools.isAvailable(environment.ASM_LICENSING_URL)
    ? [
        SolApp.ofExternal(
          AsmRouteId.app_licensing_external,
          'Licensing administration',
          SolIcon.license,
          'Internal apps',
          [AsmLicensingAuthority.VIEW_APP],
        ),
      ]
    : []),
  SolApp.ofExternal(AsmRouteId.app_sol_catalog, 'Sól Catalog', SolIcon.application, 'Internal apps', [
    AsmAuthority.VIEW_SOL_CATALOG_APP,
  ]),
  SolApp.ofExternal(AsmRouteId.app_asm_prototype, 'Prototypes', SolIcon.application, 'Internal apps', [
    AsmAuthority.VIEW_ASM_PROTOTYPE_APP,
  ]),
];
